import script from "./FileListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./FileListItem.vue?vue&type=script&setup=true&lang=js"

import "./FileListItem.vue?vue&type=style&index=0&id=0212f820&lang=scss"

const __exports__ = script;

export default __exports__